// src/components/ProfileButton.js
import React, { useContext, useState, useEffect, useRef } from 'react';
import { event } from '../utils/gtm';
import { UserContext } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL, getAuthHeaders } from '../utils/utils.js';

const ProfileButton = ({ handleLogout }) => {
  const { user } = useContext(UserContext);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // This effect handles clicking outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleManageBilling = async () => {
    event({ action: 'click_nav', category: 'Navigation', label: 'Profile: Manage Billing' });
    try {
      const response = await fetch(`${API_BASE_URL}/create-billing-portal-session`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        throw new Error('Failed to create billing portal session.');
      }
      const data = await response.json();
      window.location.href = data.url; // Redirect to Stripe
    } catch (error) {
      console.error('Error managing billing:', error);
    }
  };

  // If there's no user (e.g., during initial load), don't render anything
  if (!user || !user.picture_url) {
    return null; 
  }

  const handleLogoutClick = () => {
    setIsOpen(false); // Close the dropdown
    handleLogout();   // Call the logout function
  };

  return (
    <div className="profile-button-container" ref={dropdownRef}>
      <button onClick={() => setIsOpen(!isOpen)} className="profile-button">
        <img src={user.picture_url} alt="User profile" />
      </button>

      {isOpen && (
        <div className="profile-dropdown">
          <div className="dropdown-header">
            <strong>{user.name}</strong>
            <p>{user.email}</p>
          </div>
          <ul>
            {user.is_admin === true && (
              <li onClick={() => { navigate('/admin'); setIsOpen(false); }}>Admin Panel</li>
            )}
            {user.plan === 'pro' ? (
              <>
                <li onClick={() => { navigate('/pricing'); setIsOpen(false); }}>Pricing</li>
                <li onClick={handleManageBilling}>Manage Billing</li>
              </>
            ) : (
              <li onClick={() => {
                  event({ action: 'click_upgrade_intent', category: 'Monetization', label: 'Source: Profile Dropdown' });
                  navigate('/pricing'); setIsOpen(false);
                }}>Upgrade to Pro</li>
            )}
            <li onClick={handleLogoutClick}>Logout</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProfileButton;